import useTextDtoValue from "@/utils/use-text-dto-value";
import { TextDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Badge } from "@babackapp/ui/components/badge";

type ReturnReasonListItemProps = {
  values: TextDto[];
  count: number;
  total: number;
};

export function ReturnReasonListItem({
  values,
  count,
  total,
}: ReturnReasonListItemProps) {
  
  const label = useTextDtoValue(values);

  const t = useTranslation();


  return (
    <div className="flex justify-between bg-muted/50 rounded-lg p-4">
      <div className="text-sm text-muted-foreground font-semibold inline-flex items-center gap-2 max-w-3/5">
        <span className="size-2 min-w-2 bg-primary block rounded-full" />
        {label}
      </div>
      <div className="flex flex-wrap justify-end gap-2 content-center items-center">
        <Badge variant="outline">
          {t("analyticsDashboard.returnReasons.articleLabel", {
            articles: count,
          })}
        </Badge>
        <Badge variant="default">
          {((count / (total !== 0 ? total : 1)) * 100).toFixed(1)}%
        </Badge>
      </div>
    </div>
  );
}
